import { Injectable } from '@angular/core';

@Injectable()
export class GooglePatternNumberFormatter {
    /**
     * Transform value to formatted string using google pattern to always
     * fix to 1 or 2 decimals.
     * Examples:
     * - 7.89 going to be 7.89
     * - 7.50 going to be 7.5
     * - 123.00 going to be 123.0
     * - 1234.04 going to be 1234.04
     **/
    public transform(value: number|string): string {
        const fixedFloat = parseInt(`${parseFloat(`${value}`) * 100}`, 10) / 100;
        const localeString = fixedFloat.toLocaleString('en-US', {
            maximumFractionDigits: 2,
            minimumFractionDigits: 1
        });

        return localeString.replace(/\,/gi, '');
    }
}



// WEBPACK FOOTER //
// /codebuild/output/src560599644/src/src/app/shared/services/google-pattern-number-formatter.ts